import { DateService } from '@/coreDomainsModule/services/dateService';
import {
  OrderBasisRequestInfo,
  BulkPostOrderRequest,
  OrderBasisNextDailyInfo,
  OrderBasisNextMonthlyInfo,
  OrderBasisPastMonthlyInfo,
  PostOrderRequestInfo,
} from '@/coreInfrastructureModule/axios/generated/orderManage';
import { DisplayIArrival } from '@/recommendOrderModule/pages/interfaces/displayIArrival';
import { IOrderBasis } from '@/coreDomainsModule/entities/orderBasis';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class upsertOrderAdapter {
  /**
   * フロント側の発注情報の型、IAnnounceからBulkPostOrderResponseInfoに変換を行う
   * FIXME: Listに対してadaptするのやめてほしい（単体でやりたい）
   * @param registerOrderInfo - 登録を行う発注情報
   * @param aggregateBusinessId - 集計ID
   * @param orderBasisInfo - 発注根拠情報
   */
  public static adapt = (
    registerOrderInfo: DisplayIArrival[],
    aggregateBusinessId: string,
    orderBasisInfo: IOrderBasis
  ): BulkPostOrderRequest => {
    const adaptedOrderInfo = registerOrderInfo.map((order: DisplayIArrival): PostOrderRequestInfo => {
      // 希望納期&納期
      const crossDate = order.crossDate ? DateService.convertIDateToDate(order.crossDate) : new Date();
      return {
        orderId: order.arrivalId,
        displayId: order.displayId,
        aggregateBusinessId: aggregateBusinessId,
        desiredDeliveryDate: DateService.formatDateToISOString(crossDate), // 希望納期
        estimatedTimeOfArrival: DateService.formatDateToISOString(crossDate), // 納期
        orderAmount: order.amount,
        orderStatus: order.status ? order.status : 'Recommended',
        orderNote: order.memoText,
        updateAt: order.updateAt,
      };
    });
    const adaptedOrderBasisInfo: OrderBasisRequestInfo = {
      snapshotLatestInventoryAmount: orderBasisInfo.snapshotLatestInventoryAmount,
      snapshotExecutionDate: orderBasisInfo.snapshotExecutionDate,
      snapshotPackage: orderBasisInfo.snapshotPackage,
      snapshotMoq: orderBasisInfo.snapshotMoq,
      userAdjustedLeadTime: orderBasisInfo.userAdjustedLeadTime.value,
      userAdjustedLeadTimeUnit: orderBasisInfo.userAdjustedLeadTime.unit,
      userAdjustedStdInventoryIndexMax: orderBasisInfo.userAdjustedStdInventoryIndex.max,
      userAdjustedStdInventoryIndexMin: orderBasisInfo.userAdjustedStdInventoryIndex.min,
      userAdjustedStdInventoryIndexUnit: orderBasisInfo.userAdjustedStdInventoryIndex.option.unit,
      nextMonthlyInfos: orderBasisInfo.nextMonthlyInfos.map(
        (nextMonthlyInfo): OrderBasisNextMonthlyInfo => ({
          orderBasisTargetYear: nextMonthlyInfo.orderBasisTargetYearMonth.year,
          orderBasisTargetMonth: nextMonthlyInfo.orderBasisTargetYearMonth.month,
          userAdjustedCustomerForecastAmount: nextMonthlyInfo.userAdjustedCustomerForecastAmount.toFixed(6),
          snapshotCustomerForecastAmount: nextMonthlyInfo.snapshotCustomerForecastAmount.toFixed(6),
          snapshotPreInventoryAmount: nextMonthlyInfo.snapshotPreInventoryAmount.toFixed(6),
          dailyInfos: nextMonthlyInfo.dailyInfos.map(
            (nextDailyInfo): OrderBasisNextDailyInfo => ({
              orderBasisTargetDay: nextDailyInfo.orderBasisTargetDay,
              snapshotArrivalAmount: nextDailyInfo.snapshotArrivalAmount.toFixed(6),
            })
          ),
        })
      ),
      pastMonthlyInfos: orderBasisInfo.pastMonthlyInfos.map(
        (pastMonthlyInfo): OrderBasisPastMonthlyInfo => ({
          orderBasisTargetYear: pastMonthlyInfo.orderBasisTargetYearMonth.year,
          orderBasisTargetMonth: pastMonthlyInfo.orderBasisTargetYearMonth.month,
          snapshotCustomerForecastAmount: pastMonthlyInfo.snapshotCustomerForecastAmount.toFixed(6),
          snapshotSalesResultAmount: pastMonthlyInfo.snapshotSalesResultAmount.toFixed(6),
        })
      ),
    };
    return {
      bulkPostOrderInfo: adaptedOrderInfo,
      bulkPostOrderBasisInfo: adaptedOrderBasisInfo,
    };
  };
}
